import { Component, input, signal } from '@angular/core';
import { FieldTree, FormField, SchemaPathTree } from '@angular/forms/signals';
import { ProjectDto, StringOptionDto } from '../../../core/mceapi.client.generated';
import { apiOptSome, getNoneOptionDto } from '../../../core/mceapi.client.helpers';
import { MceImageUploadComponent } from '../../../shared/components/mce-image-upload/mce-image-upload.component';


export interface ProjectBranding {
  initialImageUrl: string;
  imageData64: string;
}

export function projectBrandingSchema(_: SchemaPathTree<ProjectBranding>) { };

export function createProjectBranding(project: ProjectDto) {
  return signal<ProjectBranding>({
    initialImageUrl: project.logoUrl?.value ?? '',
    imageData64: ''
  });
}

export function builldProjectBrandingSchema(path: SchemaPathTree<ProjectBranding>) { };

export function createNewLogoImageData64(branding: FieldTree<ProjectBranding, string>) {
  return signal<StringOptionDto>(
    branding.imageData64().dirty()
      ? apiOptSome(branding.imageData64().value())
      : getNoneOptionDto());
}

@Component({
  selector: 'project-edit-branding',
  imports: [FormField, MceImageUploadComponent],
  templateUrl: `./project-edit-branding.component.html`
})
export class ProjectBrandingComponent {

  readonly form = input.required<FieldTree<ProjectBranding>>();
}
